<script setup lang="ts">
import DeleteIcon from '@/assets/svg/sourcing/delete-red.svg?component';
import FileIcon from '@/assets/svg/file-04.svg?component';
import { formatFileSize } from '@/utils/format-file-size.util';

defineProps<{
  files: File[];
}>();

const emit = defineEmits<{
  'remove-file': [index: number];
  'clear-all': [];
}>();
</script>

<template>
  <div v-if="files.length > 0" class="flex w-full flex-col gap-3">
    <!-- Header -->
    <div class="flex items-center justify-between">
      <h3 class="m-0 font-sans text-base font-bold leading-6 text-black">
        Added Resumes ({{ files.length }})
      </h3>
      <button
        type="button"
        class="cursor-pointer border-0 font-sans text-base font-normal leading-6 text-shade-800 transition-all hover:text-shade-820"
        style="background: transparent"
        @click="emit('clear-all')"
      >
        Clear all
      </button>
    </div>

    <!-- File list with scrollbar -->
    <div
      class="flex flex-col gap-0"
      :class="files.length > 3 ? 'max-h-[180px] overflow-y-auto' : ''"
    >
      <template v-for="(file, index) in files" :key="index">
        <div class="flex items-center justify-between border-b border-tint-80 py-3">
          <div class="flex items-start gap-2">
            <!-- File icon with purple background -->
            <div
              class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-highlight-50"
            >
              <FileIcon class="h-5 w-5 text-highlight-600" />
            </div>

            <!-- File info -->
            <div class="flex flex-col">
              <span class="font-sans text-sm font-bold leading-[21px] text-black">
                {{ file.name }}
              </span>
              <span class="font-sans text-xs font-normal leading-[18px] text-shade-800">
                {{ formatFileSize(file.size) }}
              </span>
            </div>
          </div>

          <!-- Delete button -->
          <button
            type="button"
            class="hover:bg-gray-50 flex cursor-pointer items-center justify-center rounded-md border-0 p-2.5 transition-all"
            aria-label="Remove file"
            @click="emit('remove-file', index)"
          >
            <DeleteIcon class="delete-icon h-5 w-5" />
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
/* Override the delete icon stroke color */
.delete-icon :deep(path) {
  stroke: #64748b !important;
}
</style>
